import { Chips, IChipsOption } from '@cian/ui-kit';
import { useCallback } from 'react';
import { InlineFilter } from 'shared/components/InlineFilter';

interface IDealTypeSelectorProps<T> {
  value: T[];
  options: IChipsOption<T>[];
  onChange: (newValue: T | null) => void;
}

export function DealTypeSelector<T>({ onChange, value, options }: IDealTypeSelectorProps<T>) {
  const handleChange = useCallback(
    (newValue: [T]) => {
      const [nextValue] = newValue;

      onChange(nextValue === null ? null : nextValue);
    },
    [onChange],
  );

  return (
    <InlineFilter>
      <Chips onChange={handleChange} value={value} options={options} selectType="single" size="S" />
    </InlineFilter>
  );
}
